import React, { useState } from 'react';
import { Modal, Button, Input } from './common';
import { authService } from '../services/resources';
import { apiError } from '../services/api';

export default function ChangePasswordModal({ open, onClose, onToast }) {
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const reset = () => {
    setForm({ current: '', next: '', confirm: '' });
    setError('');
  };

  const close = () => {
    reset();
    onClose();
  };

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.next.length < 6) {
      setError('New password must be at least 6 characters');
      return;
    }
    if (form.next !== form.confirm) {
      setError('New password and confirmation do not match');
      return;
    }
    setSaving(true);
    try {
      await authService.changePassword(form.current, form.next);
      onToast?.('Password changed');
      close();
    } catch (err) {
      setError(apiError(err).message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={close}
      title="Change Password"
      size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={close}>
            Cancel
          </Button>
          <Button onClick={submit} disabled={saving}>
            {saving ? 'Saving…' : 'Change Password'}
          </Button>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-3">
        {error && <div className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-700">{error}</div>}
        <Input
          label="Current Password"
          type="password"
          required
          value={form.current}
          onChange={(e) => set('current', e.target.value)}
        />
        <Input
          label="New Password"
          type="password"
          required
          value={form.next}
          onChange={(e) => set('next', e.target.value)}
        />
        <Input
          label="Confirm New Password"
          type="password"
          required
          value={form.confirm}
          onChange={(e) => set('confirm', e.target.value)}
        />
      </form>
    </Modal>
  );
}
